import { Capacitor } from '@capacitor/core';
import { Haptics, ImpactStyle, NotificationType } from '@capacitor/haptics';

// Future preferences can call setEnabled; unsupported devices remain a no-op.
let enabled = true;
const patterns = {
  selection: 8,
  light: 10,
  success: [12, 30, 12],
  warning: [18, 40, 18],
  error: [20, 30, 20],
};

const notificationTypes = {
  success: NotificationType.Success,
  warning: NotificationType.Warning,
  error: NotificationType.Error,
};

const emit = async (kind) => {
  if (!enabled) return;
  try {
    if (Capacitor.isNativePlatform()) {
      // A discrete selection uses one light impact. selectionChanged alone is
      // a no-op on iOS without a selectionStart/End gesture session.
      if (kind === 'selection' || kind === 'light') await Haptics.impact({ style: ImpactStyle.Light });
      else await Haptics.notification({ type: notificationTypes[kind] });
    } else if (typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function') {
      navigator.vibrate(patterns[kind]);
    }
  } catch {
    // Tactile feedback must never reject, delay, or retry the financial action.
  }
};

export const haptics = {
  selection: () => emit('selection'),
  light: () => emit('light'),
  success: () => emit('success'),
  warning: () => emit('warning'),
  error: () => emit('error'),
  setEnabled: (value) => { enabled = Boolean(value); },
};
